import { Articles } from "../assets/articles";


const NewsCard = ({title, author, link, img}) =>{
    return(
        <>
            <div className="group relative w-fit h-fit flex-[100%] sm:flex-[40%] md:flex-[30%] flex-grow flex-shrink-0 sm:flex-shrink sm:flex-grow-0 rounded-sm transition-all duration-500 ease-in-out " >
                <a href={link} target="blank">
                    <img src={img} alt="article" className="w-full md:w-[20.4vw] h-[24vh]  sm:h-[53.3vh] object-cover object-center"/>
                
                
                    <div className="title absolute -bottom-1 -left-[1%] z-10 w-[102%] h-[70%]  sm:h-[58.1%] p-4 bg-gradient-to-t from-[rgba(10,10,10,1)] from-0% via-[rgba(10,10,10,0.8)] via-38% to-[rgba(10,10,10,0)] to-100% flex flex-col gap-1 justify-end transition-all duration-500 ease-in-out group-hover:h-[100%] group-hover:justify-center">
                        <p className=" truncate font-medium text-[var(--text)]">{title}</p>
                        <small className="truncate capitalize text-[var(--text-m)]" >by {author}</small>
                    </div>
                </a>
            </div>
        </>
    )
}

export const Convince = () =>{
    return(
        <>
            <section  className="mainWrapper min-h-fit flex flex-col items-center justify-center py-[10vh] gap-10 box-border">
                <h4 className="header capitalize" style={{textShadow:'2px 2px 5px rgba(0, 0, 0, 1)'}}>need more convincing ?</h4>
                <p className="subheader text-center w-full sm:w-[70%] md:w-[50%] text-[var(--text-h)] font-light">
                    <span>"In the digital realm, businesses have the opportunity to create immersive experiences that captivate and inspire, transcending physical limitations."</span>
                    <br />
                    <p className="block text-[var(--text-h)] mt-2 italic font-medium">~ Elon Musk</p>
                </p>
                <div className="flex flex-wrap gap-4 items-center justify-center">
                    {
                        Articles.map(article =>(
                            <NewsCard {...article}  key={article.title}/>
                        ))
                    }
                </div>
            </section>
        </>
    )
}